import type { Theme } from "@mui/material/styles";
import type { AppReportPageStyles } from "../types";

export function buildReportPageStyles(_theme: Theme): AppReportPageStyles {
  return {
    chatShell: {
      height: { xs: "calc(100vh - 148px)", md: "calc(100vh - 132px)" },
      minHeight: 420,
      width: "100%",
      maxWidth: "100%",
      borderRadius: 1.25,
      overflow: "hidden",
    },
  };
}
